import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { ContactInformationService } from './contact-information.service';
import { NgForm } from '@angular/forms';

@Component({
	selector: 'kt-contact-information',
	templateUrl: './contact-information.component.html',
	styleUrls: ['./contact-information.component.scss']
})
export class ContactInformationComponent implements OnInit {
	public AddContactType: boolean;
	public ContactType: any;
	public isAlertVisible: boolean;
	public alertType: boolean;
	public alertMsgValue: boolean;
	@Input() dropdownList: any;
	public  contactDetails: any[];
	showContactNumberField: boolean = false;
	public SearchCountryField = SearchCountryField;
	public TooltipLabel = TooltipLabel;
	public CountryISO = CountryISO;
	public separateDialCode = true;
	public phone_number;
	public showContactEmailField: boolean;
	public showContactTextField: boolean
	@ViewChild('permenantContactDetailsForm',{static: false})permenantContactDetailsForm: NgForm;
	Editing: boolean;
	index: number;
	constructor(private contactInformationService: ContactInformationService) {
		this.ContactType = {
			contactValue: '',
			contactTypeCode: '',
			primaryInd: true,
			contactType:''
		};
		//  this.dropdownList['contactType'] = [];
		this.getContactDetails();
	}

	ngOnInit() {
		let contactTypeList = [];
		contactTypeList = this.dropdownList.contactTypeList;
		for (let i = 0; i < this.dropdownList.contactTypeList.length; i++) {
			if(this.dropdownList.contactTypeList[i]  && this.dropdownList.contactTypeList[i].value &&  this.dropdownList.contactTypeList[i].value == 10191){
				contactTypeList.splice(i,1);
			}
			if(this.dropdownList.contactTypeList[i]  && this.dropdownList.contactTypeList[i].value && this.dropdownList.contactTypeList[i].value == 10195){
				contactTypeList.splice(i,1);
			}
		}
		this.dropdownList.contactTypeList = contactTypeList;
	}

	AddNewContactType() {
		this.ContactType.contactValue = null
		this.ContactType.contactValue = null;
		this.phone_number = null;
		this.AddContactType = true;
	}
	public async getContactType(e) {
		this.ContactType.contactType  = await this.dropdownList.contactTypeList.find(x => x.value == e).label;
		this.ContactType.contactTypeCode = e;
		if (e == 10195) {
			//primary cell Phone
			this.showContactNumberField = true;
			this.ContactType.primaryInd = true;
			this.ContactType.contactValue = this.phone_number;
		}
		else if (e == 101911) {
			//cell Phone
			this.showContactNumberField = true;
			this.ContactType.primaryInd = false;
			this.ContactType.contactValue = this.phone_number;
		}
		else if (e == 10193) {
			//home Phone
			this.showContactNumberField = true;
			this.ContactType.primaryInd = false;
			this.ContactType.contactValue = this.phone_number;
		}
		else if (e == 10192) {
			//office Phone
			this.showContactNumberField = true;
			this.ContactType.primaryInd = false;
			this.ContactType.contactValue = this.phone_number;
		}
		else if (e == 10194) {
			//FAX Phone
			this.showContactNumberField = true;
			this.ContactType.primaryInd = false;
			this.ContactType.contactValue = this.phone_number;
		}
		else if (e == 10196) {
			//Email Phone
			this.showContactNumberField = false;
			this.ContactType.primaryInd = false;
			this.showContactEmailField = true
			this.showContactTextField = false;
		}
		else{

			this.ContactType.primaryInd = false;
			this.showContactNumberField = false;
			this.showContactEmailField = false;
			this.showContactTextField = true;
		}
	}
	saveContactType(contact) {
		if(this.ContactType.contactValue && this.ContactType.contactValue.length > 4){
			if(this.showContactNumberField){
				if(!parseInt(this.ContactType.contactValue)){
					return false
				}
			}
			if(this.showContactEmailField){
				const pattern = new RegExp(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/);
				if(!pattern.test(this.ContactType.contactValue.toString())){
					return false;
				}
			}
			if(!this.Editing){
				this.contactDetails.push(this.ContactType);
			}
			else {
				if(this.Editing && this.index){
					this.contactDetails[this.index].contactValue = this.ContactType.contactValue;
					this.contactDetails[this.index].contactType = this.ContactType.contactType;
					this.index = null;
				}
			}
			this.saveContacts();
			this.ContactType.contactValue = null;
		}
	}
	cancelEdit() {
		this.AddContactType = false;
	}

	getContactDescription(e) {
		this.ContactType.contactValue = e.target.value;
	}

	private async  getContactDetails(){

		const res: any = await this.contactInformationService.getContactDetails().toPromise();
		this.contactDetails = res.data;
		this.AddContactType = false;
		this.ContactType.contactValue = null
		this.ContactType.contactValue = null;
		this.phone_number = null;
	}

	private async saveContacts(){
		const res: any = await this.contactInformationService.saveContacts({data:this.contactDetails}).toPromise();
		this.getContactDetails();
	}

	public deleteRow(row,i){
		this.contactDetails[i]['activeIndicator'] = false;
		this.saveContacts();
	}
	public editRow(row,i){
		this.getContactType(row.contactTypeCode);
		this.ContactType.contactValue = row.contactValue;
		this.permenantContactDetailsForm.value.getContactDescription = row.contactValue;
		this.Editing = true;
		this.index = i;
	}

}
